function Upcoming() {
  return (
    <div className="absolute right-3 top-1/2 -translate-y-1/2 flex px-1 py-px items-center bg-palette-burgundy rounded-sm">
      <span className="uppercase text-white font-medium text-xs">Upcoming</span>
    </div>
  );
}

export default Upcoming;
